export default __webpack_public_path__ + "static/media/F_Ferro.27ebaad9.svg";